import { Component, type ReactNode } from "react";

import { ErrorState } from "./states";

interface ClientErrorBoundaryProps {
  children: ReactNode;
}

interface ClientErrorBoundaryState {
  hasError: boolean;
}

export class ClientErrorBoundary extends Component<
  ClientErrorBoundaryProps,
  ClientErrorBoundaryState
> {
  public state: ClientErrorBoundaryState = { hasError: false };

  public static getDerivedStateFromError(): ClientErrorBoundaryState {
    return { hasError: true };
  }

  public componentDidCatch(): void {
    // Errors are intentionally not written to the browser console because they may contain user data.
    // Client telemetry is not enabled in Phase 1.
  }

  public render(): ReactNode {
    if (this.state.hasError) {
      return <ErrorState />;
    }

    return this.props.children;
  }
}
